@if (visible) {
  <topo-modal [isActive]="visible"
    [backgroundCanClose]="true"
    [width]="812"
    (close)="onClose()"
    [isCard]="true"
    [noBodyPadding]="true"
    id="select-columns">
    <div class="modal-header">
      <div fxLayout="row"
        fxLayoutAlign="space-between center">
        <div class="mx-4 my-4"
          fxLayout="row"
          fxLayoutAlign="space-between">
          @if (visible) {
            <h5>{{ 'TABLE.EDIT-COLUMNS' | translate }}</h5>
          }
        </div>
        <div class="dialog-close mr-4"
          (click)="onClose()"><i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="column-selection">
        <div fxLayout="row"
          fxLayoutAlign="start stretch">
          <div class="fields-section">
            <div class="title">{{ 'TABLE.AVAILABLE-FIELDS' | translate }}</div>
            <div class="body">
              @for (field of fieldsForTable; track field.uId) {
                <div>
                  <div class="field-box"
                    fxLayout="row"
                    fxLayoutAlign="start start">
                    <div fxLayout="row"
                      fxLayoutAlign="center center"
                      ref="eCheckbox"
                      class="checkbox">
                      <div ref="eLabel"
                      class=""></div>
                      <div ref="eWrapper"
                        class="checkbox-input-wrapper"
                        (click)="toggleSelected(field)"
                        [ngClass]="{'checked': isSelected(field)}"
                        role="presentation">
                        <input ref="eInput"
                          class="checkbox-input"
                          type="checkbox"
                          tabindex="-1">
                      </div>
                    </div>
                    <span class="material-icons-outlined ml-3"
                    style="width: 30px">{{ field.dataTypeIcon }}</span>
                    <span class="ml-2">{{ field.displayName }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="columns-section"
            cdkDropList
            (cdkDropListDropped)="dragDropColumn($event)">
            <div class="selected-columns">
              <div class="title">{{ 'TABLE.SELECTED-COLUMNS' | translate }}</div>
              <div class="body">
                @for (column of selectedColumns; track column.uId) {
                  <div style="margin-right: 48px">
                    <div class="selected-box"
                      cdkDrag
                      fxLayout="row"
                      fxLayoutAlign="space-between center">
                      <div fxLayout="row">
                        <div class="drag-handle">
                          <i class="icon icon-drag_handle drag-icon"></i>
                        </div>
                        <div class="label">{{ column.displayName }}</div>
                      </div>
                      <div fxLayoutAlign="end"
                        class="remove-selected">
                        <i (click)="removeSelectedColumn(column)"
                        class="icon icon-close-X"></i>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <section class="field buttons"
        fxLayout="row"
        fxLayoutAlign="start center">
        <span fxLayoutAlign="start">
          <button class="button is-secondary ml-4" (click)="resetClick()">{{ 'TABLE.RESET' | translate }}</button>
        </span>
        <span fxLayoutAlign="end"
          style="width: 100%"
          class="mr-4">
          <button class="button is-secondary mr-2"
          (click)="onClose()">{{ 'TABLE.CANCEL' | translate }}</button>
          <button class="button is-primary"
          (click)="saveClick()">{{ 'TABLE.APPLY' | translate }}</button>
        </span>
      </section>
    </div>
  </topo-modal>
}

<topo-confirm [isActive]="showConfirmReset"
  (respond)="confirmResetResponse($event)"
  title="{{ 'TABLE.CONFIRM-RESET' | translate }}"
  message="{{ 'TABLE.CONFIRM-RESET-MESSAGE' | translate }}"
  noText="{{ 'TABLE.CONFIRM-NO' | translate }}"
  yesText="{{ 'TABLE.CONFIRM-YES' | translate }}"
icon="icon-arrow-undo"></topo-confirm>
